import { useEffect } from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { MfeConfig } from '@carvana/microfrontend';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { getMfeConfig, isDevelopment } from '@/utils';

const RootComponent = () => {
  useEffect(() => {
    void MfeConfig(getMfeConfig());
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <Header />
      <Outlet />
      <Footer />
      {isDevelopment && <TanStackRouterDevtools position="bottom-right" />}
    </div>
  );
};

export const Route = createRootRoute({
  component: RootComponent,
});
